import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { WhitelistedConsumers } from "ui/organizms/Consumers";

const WhitelistedConsumersScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Consumers | Whitelisted'
    >
        <WhitelistedConsumers />
    </Screen>
);

export default memo(WhitelistedConsumersScreen);
